import EqTypeList from "./components/List"
import EqTypeForm from "./components/Form"

let module = "equipment-types"

export default [
  { path: "equipment-types", component: EqTypeList, meta: { module: module, permissions: ["equipment-access"] } },
  {
    path: "equipment-types/create",
    component: EqTypeForm,
    props: true,
    meta: { module: module, permissions: ["equipment-access"] }
  },
  {
    path: "equipment-types/edit/:id",
    component: EqTypeForm,
    props: true,
    meta: { module: module, permissions: ["equipment-access"] }
  },
]
